import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/translation/(tabs)/translation-requests/page.tsx")